import React, { useState, useEffect } from "react";
import {
  signInWithEmailAndPassword,
  signOut,
  onAuthStateChanged,
} from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { auth } from "./firebase";
import "./Login.css";
import Logo from "../assets/logo2.png"

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setIsAuthenticated(!!user);
      if (user) navigate("/dashboard");
    });
    return () => unsubscribe();
  }, [navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError(null);
    setIsLoading(true);
    try {
      await signInWithEmailAndPassword(auth, email, password);
      navigate("/dashboard");
    } catch {
      setError("Invalid email or password. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleLogout = async () => {
    await signOut(auth);
    navigate("/login");
  };

  const handleCancel = () => {
    setEmail("");
    setPassword("");
    setError(null);
    navigate("/");
  };

  return (
    <div className="login-container">
      {isAuthenticated && (
        <button className="logout-button" onClick={handleLogout}>
          Logout
        </button>
      )}

      <div className="login-wrapper">
        {/* Login Card */}
        <div className="login-box">
          <div className="logo-container">
            <img src={Logo} alt="Company Logo" className="logo" />
          </div>

          <h2>Management Login</h2>
          <p className="welcome-message">
            Please sign in to the management dashboard.
          </p>

          <form onSubmit={handleLogin}>
            <div className="form-group">
              <label>Email</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="form-input"
                placeholder="Enter your email"
                required
              />
            </div>

            <div className="form-group">
              <label>Password</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="form-input"
                placeholder="Enter your password"
                required
              />
            </div>

            {error && <p className="error-message">{error}</p>}

            <div className="button-group">
              <button type="submit" className="login-button" disabled={isLoading}>
                {isLoading ? "Logging in..." : "Login"}
              </button>

              <button
                type="button"
                className="cancel-button"
                onClick={handleCancel}
                disabled={isLoading}
              >
                Cancel
              </button>
            </div>
          </form>
        </div>

        {/* Footer */}
        <div className="login-footer">
          <p>
            Powered by <span>Luminexa Technologies</span>
          </p>
          <p className="contact">
            📧 info@luminexa.in &nbsp;|&nbsp;
            🌐 <a href="https://luminexa.in" target="_blank" rel="noreferrer">
              luminexa.in &nbsp;|&nbsp; +91 8660449970
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;
